import {
  createClient,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

const client = createClient('/rest/installer/chargingstation');

export const installerChargingStationPermissions = {
  SEARCH: 'cpms.search-installer-charging-stations',
  GET: 'cpms.get-installer-charging-station',
  ASSIGN: 'cpms.assign-installer-charging-station',
  UNASSIGN: 'cpms.unassign-installer-charging-station',
  CHANGE_ALIAS: 'cpms.change-alias-installer-charging-station',
  SEARCH_COMPANIES: 'cpms.search-installer-charging-station-companies',
  GET_COMPANIES: 'cpms.get-installer-charging-station-companies'
};

export interface AssignChargingStationRequest {
  accessCode: string;
}

export interface ChargingStationAliasRequest {
  alias: string;
}

export interface InstallerChargingStation {
  id: string;
  alias: string;
}

export interface InstallerChargingStationCompanies {
  id: string;
  companies: ChargingStationCompany[];
}

export interface ChargingStationCompany {
  id: string;
  name: string;
  alias: string;
}

export const searchInstallerChargingStations: SearchOperation<InstallerChargingStation, string> = searchRequestFactory<
  InstallerChargingStation
>(client, {
  permissionId: installerChargingStationPermissions.SEARCH
});

export const getChargingStation: FindOperation<InstallerChargingStation, string> = getRequestFactory<
  InstallerChargingStation,
  string
>(client, {
  permissionId: installerChargingStationPermissions.GET
});

export const getChargingStationCompanies: FindOperation<InstallerChargingStationCompanies, string> = getRequestFactory<
  InstallerChargingStationCompanies,
  string
>(client, {
  pattern: '/companies/{chargingStationId}',
  permissionId: installerChargingStationPermissions.GET_COMPANIES
});

export const searchChargingStationCompanies: SearchOperation<InstallerChargingStationCompanies> =
  searchRequestFactory<InstallerChargingStationCompanies>(client, {
    pattern: '/companies',
    permissionId: installerChargingStationPermissions.SEARCH_COMPANIES
  });

export const assignChargingStation: SaveOperation<AssignChargingStationRequest, never> = postRequestFactory<
  AssignChargingStationRequest,
  never
>(client, {
  pattern: '/{chargingStationId}/assign',
  permissionId: installerChargingStationPermissions.ASSIGN
});

export const unassignChargingStation: SaveOperation<undefined, never> = postRequestFactory<undefined, never>(client, {
  pattern: '/{chargingStationId}/unassign',
  permissionId: installerChargingStationPermissions.UNASSIGN
});

export const changeChargingStationAlias: SaveOperation<ChargingStationAliasRequest, never> = postRequestFactory<
  ChargingStationAliasRequest,
  never
>(client, {
  pattern: '/{chargingStationId}/change-alias',
  permissionId: installerChargingStationPermissions.CHANGE_ALIAS
});
